import { toast } from "sonner";

let lastToastAt = 0;

/**
 * Show a precision warning toast when annotating on a touch screen.
 * Fires every time an annotation is created, but with a small throttle
 * (1.5s) so a fast tap-tap-tap doesn't stack toasts.
 *
 * Call this from every annotation-creation handler (PdfCanvas, VideoCanvas,
 * ReviewItem image canvas, public ReviewLink canvas).
 */
export function warnTouchPrecision() {
  if (typeof window === "undefined") return;
  const isTouch = window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  if (!isTouch) return;
  const now = Date.now();
  if (now - lastToastAt < 1500) return;
  lastToastAt = now;
  toast.warning("Touch pin precision is limited — use a desktop or stylus for exact placement.", {
    duration: 3500,
  });
}
